import Highcharts from 'highcharts';

export const figure49 = {
  chart: {
    zoomType: 'xy',
    animation: false,
    marginTop: 50,
    marginLeft: 300,
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'bar',
    backgroundColor: 'rgba(255, 255, 255, 0.0)',
    style: {
      fontFamily: 'Montserrat'
    }
  },

  colors: ['#00b050', '#92d050', '#385723'],

  credits: {
    enabled: false
  },
  title: {
    text: null
  },
  subtitle: {
    text: null
  },

  plotOptions: {
    series: {
      borderWidth: 0,
      marker: {
        symbol: 'circle',
        enabled: false,
        states: {
          hover: {
            enabled: true,
            radius: 5
          }
        }
      }
    }
  },

  exporting: {
    enabled: false
  },
  xAxis: [{
    categories: [
      "Mundo",
      "",
      "Asia central y meridional",
      "Asia oriental y sudoriental",
      "África septentrional y Asia occidental",
      "África subsahariana",
      "Europa y América del Norte",
      "América Latina y el Caribe",
      "Oceanía",
      "Países en desarrollo sin litoral (PDL)",
      "Países menos adelantados (PMA)",
      "Pequeños Estados insulares en desarrollo (PEID)",
    ],
    lineColor: "#d7d7d7",
    tickColor: "#d7d7d7",
    tickLength: 16,
    labels: {

      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      }
    },
  }],
  yAxis: [{ // Primary yAxis
    labels: {
      format: '{value}%',
      //format: '{value}',
      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      },
    },
    max: 80,
    min: 0,
    tickInterval: 10,
    gridLineWidth: 0,
    title: {
      text: null,
      style: {
        color: Highcharts.getOptions().colors[1]
      }
    }
  }],
  tooltip: {
    shared: true,
    useHTML: true,
    hideDelay: 500,
    backgroundColor: null,
    borderWidth: 0,
    shadow: false,
    style: {
      padding: 0
    }
  },
  legend: {
    enabled: false,
  },

  series: [{
    name: '2000',
    tooltip: {
      valueSuffix: '%'
    },
    dataLabels: {
      enabled: false,
      style: {
        fontWeight: 'normal',
        textOutline: false,
        color: '#999999',
        fontSize: '12px'
      }

    },
    data: [31.9, null, 10.4, 28.5, 4.6, 31.0, 40.5, 50.8, 21.6, 18.2, 29.9, 73.2]
  },{
    name: '2010',
    tooltip: {
      valueSuffix: '%'
    },
    dataLabels: {
      enabled: false,
      style: {
        fontWeight: 'normal',
        textOutline: false,
        color: '#999999',
        fontSize: '12px'
      }

    },
    data: [31.5, null, 10.7, 29.7, 4.6, 29.5, 40.9, 48.1, 21.3, 17.5, 28.4, 73.5]
  },{
    name: '2020',
    tooltip: {
      valueSuffix: '%'
    },
    dataLabels: {
      enabled: false,
      style: {
        fontWeight: 'normal',
        textOutline: false,
        color: '#999999',
        fontSize: '12px'
      }

    },
    data: [31.2, null, 11.0, 30.1, 4.6, 27.8, 41.0, 46.7, 21.8, 16.8, 26.4, 73.2]
  }]
};